export const PLACEHOLDER =
  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect fill="%23f3f4f6" width="200" height="200"/%3E%3Ctext fill="%239ca3af" x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-size="14"%3ENo image%3C/text%3E%3C/svg%3E';

function getImageBaseUrl(): string {
  const u = import.meta.env.VITE_API_URL;
  if (u && (u.startsWith('http') || u.startsWith('//'))) return u.replace(/\/api\/?$/, '');
  return 'https://dehleze.store/api/';
}

export function getImageUrl(imagePath: string | null | undefined): string {
  if (imagePath == null || imagePath === '') return PLACEHOLDER;
  if (imagePath.startsWith('http') || imagePath.startsWith('data:')) return imagePath;
  const base = getImageBaseUrl();
  const path = imagePath.replace(/^\//, '');
  // Special handling for category images coming from /api/categories/ endpoints,
  // which return values like "category_images/Health__Beauty.jfif"
  if (path.startsWith('category_images/')) {
    return `${base.replace(/\/$/, '')}/media/${path}`;
  }
  return `${base.replace(/\/$/, '')}/${path}`;
}

export function generateImageSrcSet(imagePath: string | null | undefined): string {
  const url = getImageUrl(imagePath);
  return `${url} 1x, ${url} 2x`;
}

export async function compressImage(
  imageFile: File,
  quality = 0.8
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('Compress failed'))),
        'image/jpeg',
        quality
      );
    };
    img.onerror = () => reject(new Error('Image load failed'));
    img.src = URL.createObjectURL(imageFile);
  });
}
